import IconLabel from './component'
export { IconLabel }
export default IconLabel